<template>
  <div class="header">
    <div class="header-content">
      <div class="header-top">
        <div class="logo">
          <img src="../assets/image/10.png" alt="" width="40px">
          <span>上海三叶禾信息科技有限公司</span>
        </div>

        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          text-color="black"
          router
        >
          <li :class="'menu_li '+(activeFlag == 'index' ? 'actived': '')" @click="showCompany('index')">首页</li>
          <li :class="'menu_li '+(activeFlag == 'company' ? 'actived': '')" @click="showCompany('company')">公司简介</li>
          <el-submenu index="2">
            <template slot="title">解决方案</template>
            <el-menu-item index="/trading">二手件交易平台</el-menu-item>
            <el-menu-item index="/industryStatus">拆解厂管理系统</el-menu-item>
          </el-submenu>
          <el-menu-item index="/becomePartner">城市合伙</el-menu-item>
          <li :class="'menu_li '+(activeFlag == 'contact' ? 'actived': '')" @click="showCompany('contact')">联系我们</li>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeadMenu',
  components: {
    
  },
  data() {
    return {
      activeIndex: '/index',
      activeFlag: 'index',
    }
  },
  watch: {
    // 监听路由变化
    '$route.path': {
      handler(to, oldVal) {
        // console.log(to, oldVal, '????????!!!')
        if(to != '/index') {
          this.activeFlag = ''
        } else if(to == '/index' && oldVal == '/') {
          this.activeFlag = 'index'
        }
        this.activeIndex = to
      },
      immediate: true
    }
  },
  methods: {
    showCompany(e) {
      this.activeIndex = ''
      if(e == 'company') {
        this.activeFlag = 'company'
        if(this.$route.path === '/index') { // 当前就在首页时无需跳转页面
          let PageId = document.getElementById('toCompany')
          window.scrollTo({
            'top': PageId.offsetTop - 70,
            'behavior': 'smooth'
          })
        } else {
          this.$router.push({
            path: '/index'
          })
          this.$nextTick(() => {
            let PageId = document.getElementById('toCompany')
            window.scrollTo({
              'top': PageId.offsetTop - 70,
              'behavior': 'smooth'
            })
          })
        }
      } else if(e == 'index') {
        this.activeFlag = 'index'
        if(this.$route.path === '/index') {
          console.log(1);
        } else {
          this.$router.push({
            path: '/index'
          })
        }
      } else if(e == 'contact') {
        this.activeFlag = 'contact'
        if(this.$route.path === '/index') {
          let PageId = document.getElementById('footer')
          window.scrollTo({
            'top': PageId.offsetTop - 70,
            'behavior': 'smooth'
          })
        } else {
          this.$router.push({
            path: '/index'
          })
          this.$nextTick(() => {
            let PageId = document.getElementById('footer')
            window.scrollTo({
              'top': PageId.offsetTop - 70,
              'behavior': 'smooth'
            })
          })
        }
      }
    },
    handleSelect() {
      this.activeFlag = ''
      // console.log(key, keyPath);
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-menu.el-menu--horizontal {
  display: flex;
  border: none;
  .el-menu-item {
    height: 50px;
  }
  .el-submenu {
    .el-submenu__title {
      height: 50px;
    }
  } 
}
.header {
  height: 70px;
}
.header-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 70px;
  background-color: #fff;
  box-shadow: 0 5px 5px rgba(0,0,0,0.1);
  z-index: 5;
}
.header-top {
  width: 1280px;
  height: 70px;
  margin: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.logo {
  display: flex;
  align-items: center;
}
.menu_li {
  box-sizing: border-box;
  height: 50px;
  line-height: 60px;
  font-size: 14px;
  padding: 0 20px;
  cursor: pointer;
}
.actived {
  border-bottom: 2px solid #409EFF;
  color: #303133;
}
</style>